import provinces from 'china-division/dist/provinces.json';

const region = (provinceCode, cityCode) => {
  let strProvince = '';
  let strCity = '';
  let city = [];
  provinces.forEach(item => {
    // eslint-disable-next-line eqeqeq
    if (item.code == provinceCode) {
      strProvince = item.name;
      city = item.children;
    }
  });
  city.forEach(item => {
    // eslint-disable-next-line eqeqeq
    if (item.value == cityCode) {
      strCity = item.label;
    }
  });
  return `${strProvince}${strCity}`;
};

export default region;



// WEBPACK FOOTER //
// ./src/components/comm/getArea.js